module.exports = __webpack_public_path__ + "img/stapelmuurtje voor.7b309690.jpg";